import styled from 'styled-components/macro'

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 24px;
  gap: 20px;
`
